import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import epaStyles from './epa_tiers.module.scss'
import { VictoryAxis, VictoryChart, VictoryScatter } from "victory"
import ScatterImage from "../helper_js/scatter_image"
import Select from "react-select"

const EpaTiersTeam = () => {
    const data = useStaticQuery(graphql`
        query {
            allTeamsCsv {
                nodes {
                    season
                    team
                    epa_per_play_ytd
                    epa_per_play_against_ytd
                    team_nick
                    team_logo_espn
                    team_color
                    team_color2
                }
            }
            justTeams: allTeamsCsv {
                distinct (
                    field: team
                )
            }
        }
    `)


    const dropOptions = data.justTeams.distinct.map((node) => {
        return(
            {'value' : node, 'label' : node}
        )
    })

    const [selectedTeams, setSelectedTeams] = useState([
        {'value' : 'NE', 'label' : 'NE'},
        {'value' : 'NYJ', 'label' : 'NYJ'},
    ])

    const selectedTeamsArray = selectedTeams.map((team) => {
        return(
            team['value']
        )
    })

    return (
        <div className={epaStyles.containerWrapper}>
            <h2 className={epaStyles.section_header}>
                About EPA Tiers by Team
            </h2>
            <div className={epaStyles.about_div}>
                <p className={epaStyles.about_text}>
                    EPA tiers plot teams by their offensive (x-axis) and defensive (y-axis) performance as measured by EPA / Play.
                </p>
                <p className={epaStyles.about_text}>
                    The team tiers chart below does not include tier lines (see the 'EPA Tiers' tab), but generally speaking, it's best to be up and to the right. Because quality offense is more predictive of success, its better to be 'right' than it is to be 'up.' 
                </p>
            </div>
            <div className={epaStyles.spacer_div}></div>
            <div className={epaStyles.containerDiv}>
                <div className={epaStyles.selectContainerDiv}>
                    <Select
                        options={dropOptions}
                        onChange={setSelectedTeams}
                        placeholder='Select Teams'
                        isSearchable
                        isMulti
                    />
                </div>
                <div className={epaStyles.chartContainerDiv}>
                    <VictoryChart
                            domainPadding={{
                                y:[0,0],
                                x:[0,0]
                            }}
                            width={550}
                            height={400}
                        >
                            <VictoryAxis
                                label='Offensive EPA / Play'
                                style={{
                                    axisLabel: {
                                        fontSize: '10px',
                                        padding: '30',
                                        fontWeight: "bold"
                                    },
                                    tickLabels: {
                                        fontSize: '8px',
                                        color: '#808080',
                                    },
                                }}
                                orientation='bottom'
                                offsetY={50}
                            />
                            <VictoryAxis
                                dependentAxis
                                label='Defensive EPA / Play'
                                style={{
                                    axisLabel: {
                                        fontSize: '10px',
                                        padding: '40',
                                        fontWeight: "bold"
                                    },
                                    tickLabels: {
                                        fontSize: '8px',
                                        color: '#808080',
                                    },
                                }}
                                offsetX={50}
                            />
                            {data.allTeamsCsv.nodes.map((node) => {
                                if (selectedTeamsArray.includes(node['team'])) {
                                    const victoryData = [
                                        {
                                            x: Math.round(10000*node['epa_per_play_ytd'])/10000,
                                            y: Math.round(-10000*node['epa_per_play_against_ytd'])/10000,
                                        }
                                    ]
                                    return(
                                        <VictoryScatter
                                            dataComponent={
                                                <ScatterImage
                                                    logoUrl={node.team_logo_espn}
                                                    team={node.team}
                                                    season={node.season}
                                                    includeSeason={true}
                                                />
                                            }
                                            data={victoryData}
                                            x='x'
                                            y='y'
                                        />
                                    )
                                } else {
                                    return(null)
                                }
                            })}
                        </VictoryChart>
                    </div>
            </div>
        </div>
    )

}

export default EpaTiersTeam